import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportDocumentsComponent } from './component/transport-documents.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TransportDocumentItemComponent } from './component/transport-document-item/transport-document-item.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportPhotoButtonComponent } from './component/transport-photo-button/transport-photo-button.component';
import { TransportDocumentsListComponent } from './component/transport-document-list/transport-documents-list.component';



@NgModule({
  declarations: [
    TransportDocumentsComponent,
    TransportDocumentItemComponent,
    TransportPhotoButtonComponent,
    TransportDocumentsListComponent
    
  ],
  imports: [
    CommonModule,
    SharedModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  exports: [
    TransportPhotoButtonComponent,
    TransportDocumentsListComponent
  ]
})
export class TransportDocumentsModule { }
